var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-spacer'),(_vm.room)?_c('image-editor',{attrs:{"url":_vm.url},on:{"upload":_vm.upload,"clear":_vm.clear}}):_vm._e(),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }